<template>
  <div class="gallery">
    <div class="glide" :class="iuid">
      <div class="glide__track" data-glide-el="track">
        <ul class="glide__slides" :class="{ static: isSingleMedia }">
          <li class="glide__slide" v-for="(item, idx) in computedMedia" :class="[item.type]" :key="`gallery-item-${idx}`">
            <template v-if="item.type === 'image'">
              <img :src="item.path" alt />
            </template>
          </li>
        </ul>
      </div>
      <div v-if="hasCaptions" class="glide__bullets captions" data-glide-el="controls[nav]">
        <span
          v-for="(m, cidx) in computedMedia"
          :key="`glide__caption-${iuid}-${cidx}`"
          class="glide__bullet caption"
          v-html="m.caption"
        />
      </div>
      <div class="glide__bullets bullets" data-glide-el="controls[nav]" v-if="computedMedia.length > 1">
        <div
          v-for="(m, bidx) in computedMedia"
          :key="`glide__bullet-${iuid}-${bidx}`"
          class="glide__bullet"
          :data-glide-dir="`=${bidx}`"
        />
      </div>
    </div>
    <div data-direction="<" @click="navigate"/>
    <div data-direction=">" @click="navigate"/>
  </div>
</template>

<script>
  import Glide from '@glidejs/glide';

  let uid = 0;

  export default {
    name: 'Gallery',
    components: {
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      media: {
        type: Array,
        default: () => [],
      },
      blockContent: {
        type: Object,
        default: () => ({}),
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      uid += 1;
      return {
        iuid: `gallery-glider-${uid}`,
        instance: null,
      };
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      hasCaptions() {
        const media = this.blockContent?.media;
        if (media) {
          for (let i = 0, n = media.length; i < n; i += 1) {
            if (media[i].caption) {
              return true;
            }
          }
        }
        return false;
      },
      computedMedia() {
        const media = this.media;
        const blockMedia = this.blockContent?.media;
        if (blockMedia) {
          const out = [];
          blockMedia.forEach((m) => {
            out.push({
              type: m.type.split('/')[0],
              caption: m.caption || '',
              path: `${this.$b.contentUrl}/${m.path}`,
            });
          });
          return out;
        }
        return media;
      },
      isSingleMedia() {
        return this.computedMedia.length < 2;
      },
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    mounted() {
      this.$nextTick(() => {
        const media = this.computedMedia;
        if (media.length > 1) {
          const instance = new Glide(`.${this.iuid}`, { type: 'carousel', autoplay: false });
          instance.mount();
          this.instance = instance;
        }
      });
    },
    // beforeUpdate() {},
    // updated() {},
    beforeDestroy() {
      if (this.instance) {
        this.instance.destroy();
      }
      this.instance = null;
    },
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      navigate(evt) {
        const instance = this.instance;
        const direction = evt.currentTarget?.dataset.direction;
        if (instance && direction) {
          instance.go(direction);
        }
      },
      //----------------------------------
      // Event Handlers
      //----------------------------------
    },
  };
</script>

<style lang="scss">
@import '~@glidejs/glide/src/assets/sass/glide.core';
@import '~scss/mixins';
@import '~scss/variables';

.gallery {
  position: relative;
  margin: 0 auto;
  width: 100%;
  padding-bottom: 50%;

  @include screen-mobile {
    padding-top: 80px;
  }

  &.blocked {
    margin-bottom: 100px;
    &:last-of-type {
      margin-bottom: 0;
    }
  }

  & > .glide {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    .glide__track {
      width: inherit;
      height: inherit;
      font-size: 0;

      .glide__slides {
        width: inherit;
        height: inherit;

        .glide__slide {
          position: relative;
          overflow: hidden;
          cursor: grab;

          &.image {
            // background: rgba(0, 0, 0, 0.85);
            & > img {
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              /*
              &:first-of-type {
                object-fit: cover;
                width: 100%;
                height: 100%;
                filter: blur(7px);
                mix-blend-mode: hard-light;
                transform: translate(-50%, -50%) scale(1.05, 1.05);
                opacity: 0.4;
              }
              */
              &:last-of-type {
                width: 100%;
                height: 100%;
                object-fit: contain;
              }
            }
          }
        }

        &.static {
          .glide__slide {
            cursor: default;
          }
        }
      }
    }

    div.glide__bullets.bullets {
      display: flex;
      justify-content: center;
      margin-top: 8px;
      cursor: pointer;

      .glide__bullet {
        position: relative;
        width: 35px;
        height: 6px;
        border: 0;
        background: white;
        margin-right: 8px;
        border-radius: 0;
        transition: background $default-transition;

        &:last-of-type {
          margin-right: 0;
        }

        &:before {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          border-bottom: 1px solid black;
          border-left: 1px solid black;
        }

        &:after {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          right: 0;
          top: 0;
          border-right: 1px solid black;
          border-top: 1px solid black;
        }

        &.glide__bullet--active {
          background: currentColor;
        }
      }
    }

    div.glide__bullets.captions {
      margin-top: 8px;
      margin-bottom: 8px;
      text-align: center;
      & > span {
        display: none;
        &.glide__bullet--active {
          display: inline;
        }
      }
    }
  }

  & > div[data-direction] {
    position: absolute;
    height: 100%;
    width: 15%;
    background-color: white;
    opacity: 0;
    top: 0;
    cursor: pointer;
    &:first-of-type { left: 0; }
    &:last-of-type { right: 0; }
  }
}
</style>
